<template>
  <edit></edit>
</template>

<script>
import Edit from "./edit";
export default {
  name: "",
  components: { Edit },
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>
